import YFormLocales from './Locales';

export { YFormLocales };
export default YFormLocales;
